import { AfterViewChecked, ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChange } from '@angular/core';

import { BaseSearchResultsTableComponent } from './../../shared/base-search-results-table.component';
import { CaseIdentifier } from './../../shared/case-identifier';
import { CivilIdentitySearchCase } from '../civil-identity-search-case';

@Component({
  selector: 'app-civil-identity-search-results-table',
  templateUrl: './civil-identity-search-results-table.component.html',
  styleUrls: ['./civil-identity-search-results-table.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush // this class will manage change detection for better performance
})
export class CivilIdentitySearchResultsTableComponent extends BaseSearchResultsTableComponent
                                                      implements OnChanges, AfterViewChecked {

   @Input() cases: CivilIdentitySearchCase[];
   private rowRequiringFocus = -1;
   focusedRowNumber;

   /**
    * set the flags when the cases was pushed to this compoment
    * @param changes ;
    */
   ngOnChanges(changes: { [propName: string]: SimpleChange}) {
      // loading search reults
      if (changes['cases'] && this.cases && this.cases.length) {
        this.rowRequiringFocus = changes['cases'].previousValue ? changes['cases'].previousValue.length : 0;
      }
   }

   /**
    * set the element focused after view checked
    */
   ngAfterViewChecked() {
     if (this.rowRequiringFocus > -1) {
       this.focusRow(this.rowRequiringFocus);
     }
   }

   private focusRow(rowNumber: number) {
    const firstfocusedEleId: string = 'case-identity-search-results-row-' + rowNumber + '-action-view-case-lnk';
    const firstFocusedEle: HTMLElement = document.getElementById(firstfocusedEleId);

    if (firstFocusedEle) {
      setTimeout(() => {
        firstFocusedEle.focus();
      }, 0);
      this.rowRequiringFocus = -1;
    }
  }

   protected requestFocusForLastViewedCase() {
     const lastViewedCaseIdentifier = this.lastViewedCase;
     for (let i = 0; i < this.cases.length; i++) {
       if (this.cases[i].getCaseIdentifier().equals(lastViewedCaseIdentifier)) {
         this.focusRow(i);
         break;
       }
     }
   }

   /**
    * focused on any element in the row
    */
   focusedOnRow(row: number) {
    this.focusedRowNumber = row;
   }

   /**
    * blured on any element in the row
    */
   blurredOffRow(row: number) {
    this.focusedRowNumber = null;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-identity-search-results-table/civil-identity-search-results-table.component.ts